import { client, useMutation } from '@fhs/client';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { IHistoricalOrder } from '@rbi-ctg/menu';

export default function useEnrichCartEntries() {
  const {
    store: { number: storeId },
  } = useStoreContext();
  const { serviceMode } = useServiceModeContext();

  const { isPending, failureReason, mutateAsync } = useMutation({
    mutationFn: async (cartEntriesToReorder: IHistoricalOrder['cart']['reorderCartEntries']) => {
      const filteredReorderCartEntries = cartEntriesToReorder
        ?.filter(item => !item.isDonation)
        .map(item => {
          return {
            ...item,
            image: item?.image ? JSON.parse(item.image) : '',
          };
        });

      return await client.queries.enrichCartEntries({
        cartEntries: JSON.stringify(filteredReorderCartEntries),
        storeId: storeId ?? '',
        serviceMode,
      });
    },
    mutationKey: ['reordering', storeId, serviceMode],
  });

  return {
    enrichCartEntriesError: failureReason,
    fetchEnrichedCartEntries: mutateAsync,
    loadingEnrichCartEntries: isPending,
  };
}
